import da from './da.yml'
import de from './de.yml'
import en from './en.yml'
import fi from './fi.yml'
import fr from './fr.yml'
import it from './it.yml'
import nl from './nl.yml'
import no from './no.yml'
import sv from './sv.yml'

export default {
  ...da,
  ...de,
  ...en,
  ...fi,
  ...fr,
  ...it,
  ...nl,
  ...no,
  ...sv
}
